import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminRoute } from "@/components/AdminRoute";
import { InstallPrompt } from "@/components/InstallPrompt";

import Home from "@/pages/Home";
import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Result from "@/pages/Result";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Share from "@/pages/Share";
import Compare from "@/pages/Compare";
import Feature from "@/pages/Feature";
import { Legal } from "@/pages/Legal";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/a/:slug" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/features/:key" element={<Feature />} />
      <Route path="/s/:resultId" element={<Share />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/assessment/:slug" element={<Assessment />} />
      <Route path="/results/:resultId" element={<ProtectedRoute><Result /></ProtectedRoute>} />

      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />

      <Route path="/privacy" element={<Legal page="privacy" />} />
      <Route path="/terms" element={<Legal page="terms" />} />
      <Route path="/disclaimer" element={<Legal page="disclaimer" />} />

      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-slate-950">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <InstallPrompt />
          <Toaster position="top-center" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
